import React from "react";

export default function SectorsLikeGrid() {
  const items = [
    { title: "Business Formation", img: "/assets/images/sectorgrid/Business-Formation.gif" },
    { title: "Tax Planning", img: "/assets/images/sectorgrid/tax planing.gif" },
    { title: "Financial Reporting", img: "/assets/images/sectorgrid/financial-growth.gif" },
    { title: "Audit & Assurance", img: "/assets/images/sectorgrid/audit.gif" },
    { title: "Payroll Management", img: "/assets/images/sectorgrid/payroll.gif" },
    { title: "Bookkeeping", img: "/assets/images/sectorgrid/Bookkeeping.gif" },
    { title: "Business Advisory", img: "/assets/images/sectorgrid/BusinessAdvisory.gif" },
    { title: "Virtual CFO", img: "/assets/images/sectorgrid/VirtualCFO.gif" },
  ];

  return (
    <section className="sector-grid-section">
      <div className="sector-container">
        <div class="section-sub-title center-title sector-grid-subtitle"><img alt="Business_Consulting_services" src="assets/images/services/section-custom-menubar.png "/> <span class="sector-eyebrow">Industry sectors</span></div>
        <h2 className="sector-heading">
          <span className="highlight">Expert Accounting</span> Solutions For
          Every Business, Every Stage
        </h2>

        <div className="sector-grid">
          {items.map(({ title, img }) => (
            <div key={title} className="sector-item">
              <img src={img} alt={title} className="sector-icon" />
              <h3 className="sector-title">{title}</h3>
            </div>
          ))}
        </div>
      </div>
      <style>{`
  .sector-grid-section {
  padding: 80px 0;
  background: #fff;
  text-align: center;
  font-family: "Inter", sans-serif;
}

.sector-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.sector-grid-subtitle{
display: flex
;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.sector-eyebrow {
  font-size: 2rem;
  font-weight: 600;
  color: #000;
}

.sector-heading {
  font-size: 3rem;
  font-weight: 800;
  color: #111;
  line-height: 1.4;
  margin-bottom: 60px;
}

.sector-heading .highlight {
  color: #0086c9;
}

.sector-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px 20px;
  justify-items: center;
}

.sector-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
}

.sector-item:hover {
  transform: translateY(-5px);
}

.sector-icon {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-bottom: 16px;
}

.sector-title {
  font-size: 2rem;
  font-weight: 700;
  text-transform: capitalize;

}


@media (max-width: 1024px) {
  .sector-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .sector-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 20px;
  }

  .sector-heading {
    font-size: 1.75rem;
  }
}

@media (max-width: 480px) {
  .sector-grid {
    grid-template-columns: 1fr;
  }
}`}
</style>
    </section>
  );
}


